import { useCallback } from "react";
import { useAuth } from "./useAuth";

export const useNotificationRowHighlight = () => {
  const { currentUser } = useAuth();

  // Function to determine if a notification is new (created after last login)
  const isNotificationNew = useCallback((notification) => {
    if (!currentUser?.lastLoginDate || !notification?.createdAt) {
      return false;
    }

    try {
      let notificationDate;
      
      // Handle different timestamp formats
      if (typeof notification.createdAt.toDate === 'function') {
        // Firestore Timestamp
        notificationDate = notification.createdAt.toDate();
      } else if (notification.createdAt.seconds) {
        // Firestore Timestamp object with seconds
        notificationDate = new Date(notification.createdAt.seconds * 1000);
      } else {
        // Regular Date or string
        notificationDate = new Date(notification.createdAt);
      }

      // Convert lastLoginDate to Date if it's a Firestore Timestamp
      let lastLoginDate;
      if (typeof currentUser.lastLoginDate.toDate === 'function') {
        lastLoginDate = currentUser.lastLoginDate.toDate();
      } else {
        lastLoginDate = new Date(currentUser.lastLoginDate);
      }

      // Return true if notification was created after last login
      return notificationDate > lastLoginDate;
    } catch (error) {
      console.error("Error comparing notification date:", error);
      return false;
    }
  }, [currentUser?.lastLoginDate]);

  return {
    isNotificationNew
  };
};
